export default "__VITE_ASSET__bb468db1__"